import { OnboardingSetupStep } from '../types'

export const onboardingFirstStep: OnboardingSetupStep = 'NAME_PHONE'
